import React, { useState, useEffect } from 'react';
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds } from "../../Ads";
import imageUrl from "../../../images/eid-adha.webp";
import BlinkingText from '../../BlinkingText';
import RelatedLinks from '../RelatedLinks';
import MainCalculatorsList from './MainCalculators';
const TITLE = "كم باقي على  ليلة النصف من شعبان 2027  - العد التنازلي";
const DESCRIPTION = "كم باقي على ليلة النصف من شعبان 2027، موعد ليلة النصف من شعبان 2027، متى ليلة النصف من شعبان، تاريخ ليلة النصف من شعبان 2027، متى تكون ليلة النصف من شعبان 2027، فضل ليلة النصف من شعبان، كم باقي على النصف من شعبان 2027، ليلة البراءة 2027، الاحتفال بليلة النصف من شعبان، الدعاء في ليلة النصف من شعبان، ليلة النصف من شعبان 2027، متى يصادف النصف من شعبان 2027، ليلة النصف من شعبان في التقويم الهجري، الأعمال المستحبة في ليلة النصف من شعبان، كم باقي على ليلة النصف من شعبان، ليلة النصف من شعبان المباركة، ليلة النصف من شعبان 1446 هجري، كم يوم باقي على ليلة النصف من شعبان 2027، تاريخ ليلة النصف من شعبان، متى ليلة النصف من شعبان هذا العام، فضل شهر شعبان وليلة النصف منه، موعد ليلة النصف من شعبان في 2027";
const KEYWORDS = "كم باقي على ليلة النصف من شعبان 2027، موعد ليلة النصف من شعبان 2027، متى ليلة النصف من شعبان، تاريخ ليلة النصف من شعبان 2027، متى تكون ليلة النصف من شعبان 2027، فضل ليلة النصف من شعبان، كم باقي على النصف من شعبان 2027، ليلة البراءة 2027، الاحتفال بليلة النصف من شعبان، الدعاء في ليلة النصف من شعبان، ليلة النصف من شعبان 2027، متى يصادف النصف من شعبان 2027، ليلة النصف من شعبان في التقويم الهجري، الأعمال المستحبة في ليلة النصف من شعبان، كم باقي على ليلة النصف من شعبان، ليلة النصف من شعبان المباركة، ليلة النصف من شعبان 1446 هجري، كم يوم باقي على ليلة النصف من شعبان 2027، تاريخ ليلة النصف من شعبان، متى ليلة النصف من شعبان هذا العام، فضل شهر شعبان وليلة النصف منه، موعد ليلة النصف من شعبان في 2027";
const OG_URL = "https://do-calculate.com/articles-ar/shaban";
function Shaban() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }
        return timeLeft;
    };
    const initialDate = new Date("2027-01-22T00:00:00")
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(initialDate));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft]);
    const ramadanDates = [
        { name: 'ليلة النصف من شعبان 2027', date: new Date("2027-01-22T00:00:00") },
        { name: 'ليلة النصف من شعبان 2028', date: new Date("2028-01-11T00:00:00") },
    ];
    return (
        <div className="rtl">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className='p-3 mb-2 bg-success text-white'>
                كم باقي على ليلة النصف من شعبان 2027
            </h1>
            <div>
                <BlinkingText text="كم باقي على ليلة النصف من شعبان 2027: من المتوقع أن يبدأ ليلة النصف من شعبان 2027 يوم الجمعة بتاريخ 22/01/2027 ميلادي و14 شعبان 1448 بحسب التقويم الهجري." />
            </div>
            <div className="row">
                <div id="timer" style={{ width: '100%', fontSize: '40px' }}>
                                        <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th className="bmi-header"  >يوم</th>
                                <th className="bmi-header" >ساعة</th>
                                <th >دقيقة</th>
                                <th >ثوانٍ</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td id="days" >{timeLeft.days}</td>
                                <td id="hours">{timeLeft.hours}</td>
                                <td id="minutes" >{timeLeft.minutes}</td>
                                <td id="seconds" >{timeLeft.seconds}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div>
                        <h2 className='p-3 mb-2 bg-success text-white' style={{ color: '#333', fontSize: '36px', textAlign: 'center' }}>مواعيد عيد الاضحى القادمة</h2>
                        <table style={{ fontSize: '24px', width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '2px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f2f2f2' }}>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>موعد ليلة النصف من شعبان</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>التاريخ</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>باقي</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ramadanDates.map((ramadan, index) => (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                        <td style={{ padding: '12px' }}>{ramadan.name}</td>
                                        <td style={{ padding: '12px' }}>{ramadan.date.toLocaleDateString('en-GB')}</td>
                                        <td style={{ padding: '12px' }}>{calculateTimeLeft(ramadan.date).days} يوم</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col">
                    <MainCalculatorsList />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className='p-3 mb-2 bg-success text-white'>كم باقي على ليلة النصف من شعبان</h3>
                    <p>
                        في هذا المقال، نقدم لكم العد التنازلي المفصل لليلة النصف من شعبان، لتكونوا على اطلاع دائم بكم يوم باقٍ على وصول هذه الليلة المباركة. الكثير منا يتسائلون كم باقي على ليلة النصف من شعبان، لهذا نقدم لكم في هذا المقال العد التنازلي لليلة النصف من شعبان لتتمكنوا من معرفة كم باقي على ليلة النصف من شعبان، كم باقي على النصف من شعبان، كم يوم باقي على ليلة النصف من شعبان، شاهدوا العد التنازلي لليلة النصف من شعبان في الأعلى.
                    </p>
                    <p>
                        وفقا لموقع <a href='/calculator/ar/gregorian_to_hijri/'>تحويل التاريخ</a> يصادف ليلة النصف من شعبان  يوم الجمعة بتاريخ 22/01/2027 ميلادي و14 شعبان 1448 بحسب التقويم الهجري, يمكنكم مشاهدة العد التنازلي لليلة النصف من شعبان 2027 في هذا المقال.
                    </p>
                    <p>تجدون هنا العد التنازلي لليلة النصف من شعبان حيث يمكنكم معرفة كم باقي يوم على  النصف من شعبان.
                    </p>
                    <hr />
                    <RelatedLinks />
                    <hr />
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        احسب كم باقي ليلة النصف من شعبان
                    </h3 >
                    <p>
                        من خلال برنامج حساب العد التنازلي لليلة النصف من شعبان يمكنكم معرفة كم باقي لليلة النصف من شعبان بالتقويم الميلادي والهجري، كما يمكنكم معرفة باقي على ليلة النصف من شعبان كم يوم، وكم تبقى لليلة النصف من شعبان، كم تبقي لليلة النصف من شعبان بالأيام، ومتى ليلة النصف من شعبان العد التنازلي، باقي على ليلة النصف من شعبان، كم تبقى على ليلة النصف من شعبان، كم باقي ع ليلة النصف من شعبان، باقي كم يوم على ليلة النصف من شعبان، كم باقي عن ليلة النصف من شعبان، كم تبقى لليلة النصف من شعبان، كم متبقي على ليلة النصف من شعبان، كم يوم باقي لليلة النصف من شعبان، كم يوم على ليلة النصف من شعبان، كم بقي على ليلة النصف من شعبان، كم باقي على ليلة النصف من شعبان، باقي كام يوم على ليلة النصف من شعبان، وموعد ليلة النصف من شعبان المباركة لهذه السنة، كل عام وانتم بخير وأعاده الله علينا وعليكم باليمن والبركات.
                    </p>
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        ليلة النصف من شعبان
                    </h3>
                    <p>
                        ليلة النصف من شعبان هي ليلة الخامس عشر من شهر شعبان، وهي الليلة التي تسبق يوم 15 شعبان، وتبدأ مع مغرب يوم 14 شعبان وتنتهي مع فجر يوم 15 شعبان. ولهذه الليلة أهمية خاصّة في الإسلام، لأنه تم فيها تحويل القبلة من بيت المقدس إلى البيت الحرام بمكة المكرمة - بالعام الثاني من الهجرة على أرجح الآراء - بعد أن صلى المسلمين قرابة الستة عشر شهراً تقريباً تجاه المسجد الأقصى. ولأنه ورد فيها عدة أحاديث نبوية تبيّن فضلها وأهميتها، ويحييها عدد من المسلمين بالصلاة والذكر وتلاوة القرآن والدعاء.
                    </p>
                    <div>
                        <br />
                        <img src={imageUrl} alt="كم باقي على ليلة النصف من شعبان"
                            width="800"
                            height="450"
                            style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
                            loading="lazy"
                        />
                        <br />
                    </div>
                    <ul>
                    </ul>
                </div>
                <br />
            </div>
        </div>
    );
}
export default Shaban;